import { useNavigate } from 'react-router-dom';
import { CollapsibleChat } from '../CollapsibleChat';
import { usePopout } from '../../contexts';

export const GlobalCollapsibleChat = () => {
  const navigate = useNavigate();
  const {
    isPopoutOpen,
    isPopoutMinimized,
    closePopout,
    expandPopout,
    minimizePopout,
  } = usePopout();

  const handleMaximize = () => {
    navigate('/mga');
    expandPopout();
  };

  const handleClose = () => {
    closePopout();
  };

  return (
    <CollapsibleChat
      isOpen={isPopoutOpen}
      isMinimized={isPopoutMinimized}
      onClose={handleClose}
      onMaximize={handleMaximize}
      onMinimize={minimizePopout}
      onExpand={expandPopout}
    />
  );
};
